/**
 * Typdefinitioner för SystemPackagesManager
 * CRM Prislista - hantering av systempaket och modulpriser
 */

import i18n from '@/i18n/config';

export interface PackageModule {
  id: string;
  name: string;
  displayName: string;
  icon?: string;
  isIncluded: boolean;
}

export interface SystemPackage {
  id: string;
  systemId: string;
  name: string;
  displayName: string;
  description?: string;
  priceMonthly: number;
  priceYearly: number;
  isDefault: boolean;
  isActive: boolean;
  maxUsers?: number;
  maxVehicles?: number;
  features?: string[];
  modules: PackageModule[];
}

export interface SystemWithPackages {
  id: string;
  name: string;
  displayName: string;
  icon?: string;
  packages: SystemPackage[];
}

export interface Module {
  id: string;
  name: string;
  displayName: string;
  icon?: string;
  systemId: string;
}

export interface ModuleWithPricing {
  id: string;
  name: string;
  displayName: string;
  description: string | null;
  icon: string | null;
  route: string | null;
  systemId: string;
  systemName: string;
  systemDisplayName: string;
  priceMonthly: number;
  priceYearly: number;
  isAddon: boolean;
  pricingModel: PricingModel;
  pricingId: string | null;
}

export interface AvailableWidget {
  type: string;
  name: string;
  nameEn: string;
  description: string;
  descriptionEn: string;
  icon: string;
  defaultColumn: number;
  implemented: boolean;
}

export interface PackageFormData {
  name: string;
  displayName: string;
  description: string;
  priceMonthly: number;
  priceYearly: number;
  isDefault: boolean;
  maxUsers: string;
  maxVehicles: string;
  features: string;
  moduleIds: string[];
}

export type PricingModel = 'hourly' | 'monthly' | 'per_vehicle' | 'per_user' | 'one_time' | 'custom';

export const PRICING_MODEL_OPTIONS: { value: PricingModel; label: string }[] = [
  { value: 'hourly', get label() { return i18n.t('copy.hooks.pricingHourly'); } },
  { value: 'monthly', get label() { return i18n.t('copy.hooks.pricingMonthly'); } },
  { value: 'per_vehicle', get label() { return i18n.t('copy.hooks.pricingPerVehicle'); } },
  { value: 'per_user', get label() { return i18n.t('copy.hooks.pricingPerUser'); } },
  { value: 'one_time', get label() { return i18n.t('copy.hooks.pricingOneTime'); } },
  { value: 'custom', get label() { return i18n.t('copy.hooks.pricingCustom'); } },
];

export const getPricingModelLabel = (model: string | undefined): string => {
  const option = PRICING_MODEL_OPTIONS.find(o => o.value === model);
  return option?.label || i18n.t('copy.hooks.pricingMonthly');
};

export const formatPrice = (price: number): string => {
  return new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK' }).format(price);
};

export interface SystemModule {
  id: string;
  name: string;
  displayName: string;
  icon?: string;
  systemId: string;
  systemName: string;
}
